import { IdTutorialStep } from "../../IdTutorialStep";
export var checkTutorialNeedFocusOnBuilding = function (path) { return function (action, state$, dependencies) {
    if (action.tutorialStep === IdTutorialStep.harvestCorn_clickAcre) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.sowWildflowers_clickAcre) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.constructWindmill_confirmPlacement) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.confirmConstruction) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.produceChickenFeed_clickWindmill) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.harvestWildflowers_clickAcre) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/checks/checkTutorialNeedFocusOnBuilding.ts
// module id = 2468
// module chunks = 3